import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { ImageUrl } from "../../../../../Helpers/request";
import { LazyLoadImage } from "react-lazy-load-image-component";
function LearnDiamond() {
  return (
    <>
      <section className="Lt_LearnDiamond_section">
        <Container >
          <Row className="m-0 w-100">
            <Col lg={6}>
              <div className="am1_box_mobile">
                <div className="zoom-image">
                  <LazyLoadImage
                    src={`${ImageUrl}theme/london/h-diamond.png`}
                    className="img-responsive"
                    alt="Diamonds"
                  />
                  <div className="position-btn">
                    <Link to="/education">
                      Learn More
                    </Link>
                  </div>
                </div>
                <div className="contentsec">
                  <LazyLoadImage
                    src={`${ImageUrl}theme/london/h-pattern-1.svg`}
                    alt="Pattern"
                  />
                  <h2>Learn Diamond</h2>
                  <p>
                    Until the middle of the twentieth century, there was no
                    agreed-upon standard by which diamonds could be judged.
                  </p>
                </div>
              </div>
            </Col>
            <Col lg={6}>
              <div className="am1_box_mobile">
                <div className="zoom-image">
                  <LazyLoadImage
                    src={`${ImageUrl}theme/london/h-showroom.jpg`}
                    className="img-responsive"
                    alt="Our Showroom"
                  />
                  <div className="position-btn">
                    <Link to="/about">Learn More</Link>
                  </div>
                </div>
                <div className="contentsec">
                  <LazyLoadImage
                    src={`${ImageUrl}theme/london/h-pattern-1.svg`}
                    alt="Pattern"
                  />
                  <h2>Our Showroom</h2>
                  <p>
                    Visit one of our showrooms, and talk to a friendly diamond
                    expert to find out how we can best cater to your budget and
                    design requirements.
                  </p>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}

export default LearnDiamond;
